import styled from "styled-components";

export const OtherDaysStyled = styled.div`
  .other-days__date-picker {
    display: flex;
    align-items: center;
    justify-content: center;

    flex-basis: 14.2%;
    padding: 0 3px;
  }
`;
